import classNames from 'classnames';
import React from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {RemoveButton} from './_card_tag_remove_button';
import {useAnalyticsEvent} from '../../contexts/_analyticsEvent';
import {redirectConsumersToV2} from '../../modules/route_utils';

const SEARCH_PATHNAME = '/search';
const ENTER_KEY = 'Enter';

const CardTag = ({
  id,
  name,
  isHighlighted,
  disabled,
  isLinkToSearchResults,
  onRemoveTag,
  handleOnSelect,
  origin
}, {
  appData: {v2Host}, utils: {user, company}
}) => {
  const {trackTagClickEvent} = useAnalyticsEvent();
  const location = useLocation();
  const history = useHistory();
  const state = {
    ...location.state,
    tagClickedEvent: {
      id,
      origin
    }
  };

  const goToSearch = event => {
    handleOnSelect?.();
    trackTagClickEvent && trackTagClickEvent({id, name}, location.pathname, event);

    if(!redirectConsumersToV2({v2Host, v2Path: SEARCH_PATHNAME, v2Search: `?tags=${id}`, user, company})) {
      if(location.pathname === SEARCH_PATHNAME) {
        history.replace(SEARCH_PATHNAME, state);
      }
      else {
        history.push(SEARCH_PATHNAME, state);
      }
    }
  };

  const handleClick = goToSearch;
  const handleKeyDown = event => {
    if(event.key === ENTER_KEY) {
      event.preventDefault();
      goToSearch();
    }
  };

  return (
    <div
      className={classNames(
        'card-tag',
        {
          'card-tag-display': !isLinkToSearchResults,
          'card-tag-highlighted': isHighlighted,
          'card-tag-disabled': isLinkToSearchResults && disabled,
          'card-tag-removable': Boolean(onRemoveTag)
        }
      )}
      data-testid="card-tag"
      {...isLinkToSearchResults && !disabled ? {tabIndex: 0, onClick: handleClick, onKeyDown: handleKeyDown} : {}}>
      <span
        className="card-tag-name"
        title={name}>
        {name}
      </span>
      {onRemoveTag && <RemoveButton tagId={id} onRemoveTag={onRemoveTag} />}
    </div>
  );
};

CardTag.contextTypes = {
  appData: PropTypes.object.isRequired,
  utils: PropTypes.object.isRequired
};

CardTag.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  isHighlighted: PropTypes.bool,
  disabled: PropTypes.bool,
  isLinkToSearchResults: PropTypes.bool,
  onRemoveTag: PropTypes.func,
  handleOnSelect: PropTypes.func,
  origin: PropTypes.oneOf(['card', 'search_suggestion'])
};

CardTag.defaultProps = {
  isHighlighted: false,
  disabled: false,
  isLinkToSearchResults: true,
  onRemoveTag: undefined,
  handleOnSelect() {},
  origin: 'card'
};

export default CardTag;
